// 处理产品变体逻辑
class ProductSelector extends HTMLElement {
    currentVariantId;
    options;
    root;
    loading = false;
    constructor() {
      super();
    }
    connectedCallback() {
      this.currentVariantId = JSON.parse(this.dataset.currentVariantId);
      if (!this.currentVariantId) {
        throw new Error('选择器未传入变体');
      }
      this.options = this.dataset.options;
      this.init();
    }
    // 初始化 change 事件
    init() {
      this.bandOptionsSelector();
      this.bandVersionSelector();
      this.bindVersionEvents();
      this.updatePrice();
    }
    bandOptionsSelector() {
      const options = Array.from(
        this.getElementsByClassName('product-normal-option')
      );
  
      options.forEach((el) => {
        el.addEventListener('change', () => {
          const { productUrl, variantId, sectionId } = el.dataset;
          this.updateVersionSelector({ productUrl, variantId, sectionId });
          this.updateURL(productUrl, variantId);
          // 通知care更新
          const careProducts = document.querySelector('care-product-list');
          const careDialog = document.querySelector(
            'product-detail-dialog-hovercare-choose'
          );
          if (careDialog) {
            careDialog.updateSelectProduct();
          }
          if (careProducts) {
            careProducts.updateSelectProduct();
          }
        });
      });
    }
    bandVersionSelector() {
      const versionOptions = Array.from(
        this.getElementsByClassName('product-version-option')
      );
      versionOptions.forEach((el) => {
        el.addEventListener('change', () => {
          const { productUrl, variantId, sectionId } = el.dataset;
          this.updateURL(productUrl, variantId);
          this.updateSwiper(productUrl, variantId, sectionId);
        });
      });
    }
    // Version Selector 更新函数 — 共享一次 fetch 响应，避免双重请求
    updateVersionSelector({ productUrl, variantId, sectionId }) {
      if (!variantId) return;
  
      this.fetchSectionHTML(productUrl, variantId, sectionId)
        .then((html) => {
          this.applyVersionSelectorDOM(html);
          this.applySwiperDOM(html);
          this.updateURL(productUrl, variantId);
        })
        .catch(() => {})
        .finally(() => {
          this.toggleLoading(false);
        });
    }

    // 统一 fetch —— 返回已解析的 Document，供调用方复用
    async fetchSectionHTML(productUrl, variantId, sectionId) {
      this.toggleLoading(true);
      const response = await fetch(
        `${productUrl}?variant=${variantId}&section_id=${sectionId}`
      );
      if (!response.ok) throw new Error(`网络错误：${response.status}`);
      const text = await response.text();
      return new DOMParser().parseFromString(text, 'text/html');
    }

    // 更新 Version Selector DOM
    applyVersionSelectorDOM(html) {
      const currentElement = document.getElementById('product-version-selector');
      const newElement = html.getElementById('product-version-selector');
      if (newElement && currentElement) {
        currentElement.parentNode.replaceChild(newElement, currentElement);
        this.bandVersionSelector();
        this.bindVersionEvents();
      }
    }

    // 更新 Swiper DOM
    applySwiperDOM(html) {
      const currentSwiper = document.querySelector('zz-product-swiper');
      const newSwiper = html.querySelector('zz-product-swiper');
      if (currentSwiper && newSwiper) {
        currentSwiper.parentNode.replaceChild(newSwiper, currentSwiper);
      }
      const photoTab = document.querySelector('.gallery-tab-item[data-test-value="photo"]');
      if (photoTab) photoTab.click();
    }
  
    // 更新路由参数和产品信息
    updateURL(productUrl, variantId) {
      const currentUrl = new URL(window.location);
      currentUrl.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', currentUrl.toString());
      this.currentVariantId = variantId;
      this.updatePrice();
    }
  
    disconnectedCallback() {}
  
    // 更新价格
    updatePrice() {
      const bar = document.querySelector('buy-bottom-bar');
      if (bar) {
        bar.updatePrice();
      }
    }
  
    // loading 状态
    toggleLoading(state) {
      this.loading = state !== undefined ? state : !this.loading;
    }
  
    // version 选项变更时单独 fetch（非 option 联动时的独立入口）
    async updateSwiper(productUrl, variantId, sectionId) {
      try {
        const html = await this.fetchSectionHTML(productUrl, variantId, sectionId);
        this.applySwiperDOM(html);
      } catch (_) {
      } finally {
        this.toggleLoading(false);
      }
    }
  
    bindVersionEvents() {
      const versionOptions = Array.from(
        this.querySelectorAll('.version-selector-item > button.show-detail')
      );
      versionOptions.forEach((el) => {
        el.addEventListener('click', (event) => {
          const detailButton = event.target.closest('.show-detail');
          if (detailButton) {
            event.stopPropagation();
            event.preventDefault();
            const dialog = detailButton
              .closest('.version-selector-item')
              ?.querySelector('dialog');
            if (dialog) dialog.showModal();
          }
        });
      });
    }
  }
  
  class ProductCounter extends HTMLElement {
    constructor() {
      super();
      this.input = null;
      this.min = parseInt(this.getAttribute('min')) || 1;
      this.max = parseInt(this.getAttribute('max')) || 99;
    }
  
    connectedCallback() {
      this.input = this.querySelector('input');
      if (this.input) {
        this.init();
      }
    }
  
    disconnectedCallback() {
      const minusButton = this.querySelector('.minus');
      const addButton = this.querySelector('.add');
      if (minusButton) {
        minusButton.removeEventListener('click', this.decrementValue);
      }
      if (addButton) {
        addButton.removeEventListener('click', this.incrementValue);
      }
      if (this.input) {
        this.input.removeEventListener('input', this.handleInput);
        this.input.removeEventListener('blur', this.handleBlur);
      }
    }
  
    init() {
      const minusButton = this.querySelector('.minus');
      const addButton = this.querySelector('.add');
  
      if (minusButton) {
        minusButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.decrementValue();
        });
      }

      if (addButton) {
        addButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.incrementValue();
        });
      }
  
      this.input.addEventListener('input', (e) => this.handleInput(e));
      this.input.addEventListener('blur', () => this.handleBlur());
    }
  
    handleInput() {
      let value = parseInt(this.input.value);
      if (isNaN(value)) {
        this.input.value = '';
      } else {
        value = Math.min(Math.max(value, this.min), this.max);
        this.input.value = value;
      }
      // this.toggleButtonState();
    }
  
    handleBlur() {
      let value = parseInt(this.input.value);
      if (isNaN(value) || value < this.min) {
        this.input.value = this.min;
      } else if (value > this.max) {
        this.input.value = this.max;
      }
      this.updatePrice();
      // this.toggleButtonState();
    }
  
    decrementValue() {
      let value = parseInt(this.input.value) || this.min;
      value = Math.max(value - 1, this.min);
      this.input.value = value;
      this.updatePrice();
      // this.toggleButtonState();
    }
  
    incrementValue() {
      let value = parseInt(this.input.value) || this.min;
      value = Math.min(value + 1, this.max);
      this.input.value = value;
      this.updatePrice();
      // this.toggleButtonState();
    }
  
    toggleButtonState() {
      const minusButton = this.querySelector('.minus');
      const addButton = this.querySelector('.add');
  
      if (minusButton) {
        minusButton.disabled = parseInt(this.input.value) <= this.min;
      }
      if (addButton) {
        addButton.disabled = parseInt(this.input.value) >= this.max;
      }
    }
  
    updatePrice() {
      const bar = document.querySelector('buy-bottom-bar');
      if (bar) {
        bar.updatePrice();
      }
    }
  }
  
  customElements.define('product-counter', ProductCounter);
  customElements.define('product-selector', ProductSelector);
  